import { PaymentGatewayType } from '../PaymentGateway/PaymentGatewayType';

const StripePaymentUrlFormat = 'https://dashboard.stripe.com/payments/';
const YandexPaymentUrlFormat = 'https://yookassa.ru/my/payments/';

export function getGatewayPaymentUrl(gatewayType?: PaymentGatewayType, externalId?: string): string | null {
    if (!gatewayType || !externalId) return null;

    switch (gatewayType) {
        case PaymentGatewayType.Stripe:
        case PaymentGatewayType.NewStripe:
            return `${StripePaymentUrlFormat}${encodeURIComponent(externalId)}`;
        case PaymentGatewayType.YandexCheckout:
            return `${YandexPaymentUrlFormat}${encodeURIComponent(externalId)}`;
        default:
            return null;
    }
}
